(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4949],{

/***/ 11962:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise",
      function () {
        return __webpack_require__(74338);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(305);
/* harmony import */ var _Column_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29165);
/* harmony import */ var _Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Column_module_scss__WEBPACK_IMPORTED_MODULE_5__);








// Having one file with all components takes up less than half the space in yarn analyze
// I have moved all others to archive for now
var Column = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
});
var Item = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var flex = _param.flex, className = _param.className, childClassName = _param.childClassName, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "flex",
        "className",
        "childClassName",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), className),
        style: {
            flex: flex
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().itemChild), childClassName)
        }, props), {
            children: children
        }))
    });
});
var Content = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content), className)
    }, props), {
        children: children
    }));
});
var Card = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, children = _param.children, href = _param.href, noHoverShadow = _param.noHoverShadow, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "href",
        "noHoverShadow"
    ]);
    var Elem = "div";
    if (href) {
        Elem = _Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Elem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().card), noHoverShadow && (_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().noHoverShadow), className),
        href: href
    }, props), {
        children: children
    }));
});
var Headline = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headline), className)
    }, props), {
        children: children
    }));
});
var ImageType = {
    DEFAULT: (_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image),
    ICON: (_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
    SMALLER_ICON: (_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().smallerIcon)
};
var Image = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, children = _param.children, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "type"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(type, className)
    }, props), {
        children: children
    }));
});
Image.Type = ImageType;
var Action = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().action), className)
    }, props), {
        children: children
    }));
});
var List = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, isCardList = _param.isCardList, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "isCardList",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().list), isCardList && (_Column_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cardList), className)
    }, props), {
        children: children
    }));
});
Column.Content = Content;
Column.Headline = Headline;
Column.Image = Image;
Column.Item = Item;
Column.Card = Card;
Column.Action = Action;
Column.List = List;
/* harmony default export */ __webpack_exports__["Z"] = (Column);


/***/ }),

/***/ 17876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53068);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Img_module_scss__WEBPACK_IMPORTED_MODULE_3__);






// import { LazyImage } from 'react-lazy-images';

// eslint-disable-next-line react/prop-types
var Img = function(_param) {
    var className = _param.className, wrapperClassName = _param.wrapperClassName, height = _param.height, width = _param.width, src = _param.src, alt = _param.alt, style = _param.style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "wrapperClassName",
        "height",
        "width",
        "src",
        "alt",
        "style"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container)),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "inline-block",
            color: "transparent"
        }, style), {
            height: height,
            width: width
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeIn)),
            loading: "lazy",
            src: src,
            alt: alt,
            height: height,
            width: width
        }, props))
    });
};
Img.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 74338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ enterprise; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../@hiredigital/ui/src/LoadingArea/index.jsx
var LoadingArea = __webpack_require__(84585);
// EXTERNAL MODULE: ./src/components/Layout/Layout.jsx
var Layout = __webpack_require__(93651);
// EXTERNAL MODULE: ./src/components/PageComponents/Hero/NewEnterpriseHero/index.jsx
var NewEnterpriseHero = __webpack_require__(89122);
// EXTERNAL MODULE: ./src/components/Section/index.jsx
var Section = __webpack_require__(50943);
// EXTERNAL MODULE: ./src/components/Column/Column.jsx
var Column = __webpack_require__(33178);
// EXTERNAL MODULE: ./src/components/Img/index.jsx
var Img = __webpack_require__(17876);
// EXTERNAL MODULE: ./src/components/PageComponents/NewEnterpriseFutureOfWork/Styles.module.scss
var Styles_module = __webpack_require__(88991);
var Styles_module_default = /*#__PURE__*/__webpack_require__.n(Styles_module);
;// CONCATENATED MODULE: ./src/components/PageComponents/NewEnterpriseFutureOfWork/index.jsx

// import classNames from 'classnames';




var EnterpriseFutureOfWork = function(param) {
    var className = param.className, style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionContainer */.S, {
        anchor: "future-of-work",
        className: (Styles_module_default()).container,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
            textColor: Section/* Section.Color.WHITE */.$.Color.WHITE,
            title: "Join the Future of Work With the Best Talent in Digital",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default.List */.Z.List, {
                isCardList: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default.Card */.Z.Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Image */.Z.Image, {
                                type: Column/* default.Image.Type.ICON */.Z.Image.Type.ICON,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                    className: (Styles_module_default()).image,
                                    height: 75,
                                    width: 75,
                                    title: "on demand teams",
                                    alt: "on demand teams",
                                    src: "/img/enterprise/on-demand.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Headline */.Z.Headline, {
                                children: "On Demand Teams"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Content */.Z.Content, {
                                children: "A fully vetted team with the skills and infrastructure needed to complete custom projects."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default.Card */.Z.Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Image */.Z.Image, {
                                type: Column/* default.Image.Type.ICON */.Z.Image.Type.ICON,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                    className: (Styles_module_default()).image,
                                    height: 75,
                                    width: 75,
                                    title: "ongoing engagements",
                                    alt: "ongoing engagements",
                                    src: "/img/enterprise/individual-engagement.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Headline */.Z.Headline, {
                                children: "Ongoing Engagements"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Content */.Z.Content, {
                                children: "Kickstart talent engagements within the organization, tailored to complement existing resources."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default.Card */.Z.Card, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Image */.Z.Image, {
                                type: Column/* default.Image.Type.ICON */.Z.Image.Type.ICON,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                    className: (Styles_module_default()).image,
                                    height: 75,
                                    width: 75,
                                    title: "project-based engagements",
                                    alt: "project-based engagements",
                                    src: "/img/enterprise/multiple-engagement.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Headline */.Z.Headline, {
                                children: "Project-Based Engagements"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default.Content */.Z.Content, {
                                children: "Work with skilled individuals to fulfil your requirements for standalone projects."
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var NewEnterpriseFutureOfWork = (EnterpriseFutureOfWork);

;// CONCATENATED MODULE: ./src/pages/enterprise/index.jsx








// import Styles from './New.module.scss';
var NewEnterpriseHowItWorks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4246).then(__webpack_require__.bind(__webpack_require__, 54246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54246)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 950
        });
    },
    ssr: false
});
var NewEnterpriseHireTheBest = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9483).then(__webpack_require__.bind(__webpack_require__, 9483));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9483)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 938
        });
    },
    ssr: false
});
var NewEnterpriseWhyChoose = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8468).then(__webpack_require__.bind(__webpack_require__, 48468));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48468)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingArea/* default */.Z, {
            height: 779
        });
    },
    ssr: false
});
var RightTriangle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7037).then(__webpack_require__.bind(__webpack_require__, 57037));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57037)
            ];
        }
    },
    ssr: false
});
var LeftTriangle = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6322).then(__webpack_require__.bind(__webpack_require__, 46322));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46322)
            ];
        }
    },
    ssr: false
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2929).then(__webpack_require__.bind(__webpack_require__, 92240));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92240)
            ];
        }
    },
    ssr: false
});
var PostSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7448).then(__webpack_require__.bind(__webpack_require__, 59450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59450)
            ];
        }
    },
    ssr: false
});
var EnterpriseCaseStudy = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4591), __webpack_require__.e(2840)]).then(__webpack_require__.bind(__webpack_require__, 48444));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48444)
            ];
        }
    },
    ssr: false
});
var NewEnterpriseBuildYourTeam = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 177).then(__webpack_require__.bind(__webpack_require__, 177));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(177)
            ];
        }
    },
    ssr: false
});
var ClientTestimonial = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4591), __webpack_require__.e(3614)]).then(__webpack_require__.bind(__webpack_require__, 98214));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98214)
            ];
        }
    },
    ssr: false
});
var NewEnterprisePage = function(_param) {
    var hero = _param.hero, head = _param.head, benefits = _param.benefits, capabilities = _param.capabilities, survey = _param.survey, metrics = _param.metrics, footer = _param.footer, midCtaSection = _param.midCtaSection, customerNames = _param.customerNames, cardUsers = _param.cardUsers, posts = _param.posts, postData = _param.postData, props = (0,_object_without_properties/* default */.Z)(_param, [
        "hero",
        "head",
        "benefits",
        "capabilities",
        "survey",
        "metrics",
        "footer",
        "midCtaSection",
        "customerNames",
        "cardUsers",
        "posts",
        "postData"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        darkFooter: true,
        footerData: footer,
        pageHead: head,
        variant: Layout/* default.Variants.ENTERPRISE */.Z.Variants.ENTERPRISE,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseHero/* default */.Z, {
                customerNames: customerNames,
                users: [],
                title: "Build Digital Teams with the Best Talent on Demand",
                description: "Hire Digital offers world-class on demand talent and teams to enterprise customers, with the support and agility organizations need to get work done.",
                brandCtaLinkTo: "/schedule-call",
                brandCtaLabel: "Schedule a Consultation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseFutureOfWork, {
                style: {
                    marginTop: "-350px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseHowItWorks, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseHireTheBest, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseWhyChoose, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnterpriseCaseStudy, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEnterpriseBuildYourTeam, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientTestimonial, {
                isEnterprise: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightTriangle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSection, {
                isEnterprise: true,
                title: "Read Hire Digital Stories",
                posts: posts,
                postData: postData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                isEnterprise: true
            })
        ]
    });
};
NewEnterprisePage.propTypes = {
    hero: (prop_types_default()).object,
    head: (prop_types_default()).object,
    footer: (prop_types_default()).object,
    midCtaSection: (prop_types_default()).object,
    customerNames: (prop_types_default()).array,
    cardUsers: (prop_types_default()).array,
    posts: (prop_types_default()).array,
    postData: (prop_types_default()).array
};
var __N_SSG = true;
/* harmony default export */ var enterprise = (NewEnterprisePage);


/***/ }),

/***/ 80220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64839);

/* harmony default export */ __webpack_exports__["Z"] = (_Loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 84585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80220);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




var LoadingArea = function(param) {
    var height = param.height, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: "".concat(height, "px"),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            color: _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Color.BLUE */ .Z.Color.BLUE,
            type: _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.FULL */ .Z.Type.FULL
        })
    });
};
LoadingArea.propTypes = {
    height: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
    ]),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingArea);


/***/ }),

/***/ 29165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"Column_list__b5Q67","cardList":"Column_cardList__Re_0L","item":"Column_item___57RQ","itemChild":"Column_itemChild__svdTC","headline":"Column_headline__GXFtr","content":"Column_content__880Ra","icon":"Column_icon__x_syt","smallIcon":"Column_smallIcon__5HnHU","smallerIcon":"Column_smallerIcon__fWu3U","card":"Column_card__HF4Gc","noHoverShadow":"Column_noHoverShadow__Stj7V","action":"Column_action__RRgJD"};

/***/ }),

/***/ 53068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Img_fadeIn__2th1r","container":"Img_container__MfUcM","image":"Img_image__C4ftI"};

/***/ }),

/***/ 88991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"Styles_image__YmcmK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [856,6151,8579,3651,1854,9774,2888,179], function() { return __webpack_exec__(11962); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);